import { render, staticRenderFns } from "./MsgTemplateList.vue?vue&type=template&id=7bceaa26&scoped=true&"
import script from "./MsgTemplateList.vue?vue&type=script&lang=js&"
export * from "./MsgTemplateList.vue?vue&type=script&lang=js&"
import style0 from "./MsgTemplateList.vue?vue&type=style&index=0&id=7bceaa26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bceaa26",
  null
  
)

export default component.exports